<ul *ngIf="accounts$ | async">
  <li *ngFor="let account of accounts">{{ account.user }}</li>
</ul>
